<template>

    <div class="app-card" >
        <div class="head">
            <h3>{{ params.title }} </h3>
            <div class="icons">
                    <IconButton
                    v-if="true"
                    v-tooltip="`Execute this app`"
                    :icon="'play_circle'"
                    :width="32"
                    :height="32"
                    :type="'click'"
                    @click="startApp(params.code)"
                  />
            </div>
        </div>

        
          <img class="app-image" :src="imageURL" alt="Project Image"/>
        
        <div class="body__grid">

            <div class="body__grid-field">
                <div class="description">Description</div>
                <div class="value">{{ params.description }}</div>
                </div>

                <div class="body__grid-field">
                <div class="description">Code</div>
                <div class="value">{{ params.code }}</div>
                </div>

                <div class="body__grid-field">
                <div class="description">Author</div>
                <div class="value">{{ params.author }}</div>
                </div>

                <div class="body__grid-field">
                <div class="description">Help</div>
                <div class="value">{{ params.docs }}</div>
            
                </div>

        </div>
    </div>
    
</template>

<script setup>
import {ref, defineEmits,defineProps,computed } from 'vue';
import IconButton from '@/components/IconButton.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();
const dataConnect = new DatastoreConnect();
const emit = defineEmits(['app_selected']);

const props = defineProps({
  params: {
    type: Object,
    required: true,
  },
});

const loading = ref(false);

function startApp(code) {
    emit('app_selected',code);
}


function formatTime(str) {
  return `${new Date(str).toLocaleTimeString('default', {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
  })}`;
}

const imageURL = computed(() => {
    let url=`/resource/image?type=app&id=${props.params.id}`
    return url;

});

</script>

<style lang="scss" scoped>
.app-card {
    min-width: 350px;
    min-height: 400px;
    max-width: 350px;
  display: flex;
  flex-direction: column;
  position: relative;
  height: fit-content;
  padding: 0;
  margin: 0;
  text-align: left;
  overflow: hidden;
  border-radius: 8px;
  margin: 10px;
  border: 1px solid rgb(193, 193, 193);

  box-shadow: 2px 2px 6px 6px rgba(162, 162, 162, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
}

.head {

    padding: 2px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding-left: 8px;
    padding-right: 8px;
}

.app-image {
  height: 180px;
  width: 100%;
  overflow: hidden;
  object-fit: contain;
}


.icons {
    margin-left: auto;
}

</style>